import script from "./DropdownItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownItem.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownItem.vue?vue&type=style&index=0&id=5870f805&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5870f805"]])

export default __exports__